import { useState } from "react";
import { Button, LinearProgress, Modal, Typography } from "@mui/material";
import styled from "styled-components";

import { useTranslation } from "react-i18next";

interface Props {}

export function CaseInProgressModal(props: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  function handleClose() {
    setIsOpen(false);
  }

  return render();

  function render() {
    return (
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Styles>
          <Typography variant="h2">{t("label.caseCalculationInProgress")}</Typography>
          <Typography>{t("label.caseCalculationInProgressDescription")}</Typography>
          <LinearProgress />

          <Button onClick={handleClose}>{t("label.continueViewingTheCase")}</Button>
        </Styles>
      </Modal>
    );
  }
}

const Styles = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: ${({ theme }) => theme.palette.background.default};
  box-shadow: 24px;
  padding: ${({ theme }) => theme.spacing(4)};
`;
